import { createStore } from 'vuex'
import auth from './modules/auth'
import data from './modules/data';
import save from './modules/save';
import list from './modules/list';
import dataTableItemsDebug from './modules/dataTableItemsDebug';
import dataTableConfigurations from "@/store/modules/dataTableConfigurations";
import dataCharts from "@/store/modules/dataCharts";
import Items from './modules/items';
import dragAndDrop from "@/store/modules/dragAndDrop";
import searchApp from './modules/searchApp'
import progressPlugin from "@/plugins/progressPlugin";
import tabsFields from "@/store/modules/tabsFields";
import index from  "@/store/modules/index"
import ErrorHolder from './modules/error'
import UserHistory from './modules/user-history'
import dashboard from "@/store/modules/dashboard";
import  dummy from "@/store/modules/dummy"
import  entityManager from "@/store/modules/entityManager"
import  pinnedNav from "@/store/modules/pinnedNav"

export default createStore({
  plugins: [ progressPlugin],
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    globalLoading : false,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    SET_GLOBAL_LOADING(state,payload) {
      state.globalLoading = payload;
    }
  },
  getters : {
    GLOBAL_LOADING: state => state.globalLoading,

  },
  actions: {
  },
  modules: {
    auth,
    searchApp,
    data,
    save,
    entityManager,
    list,
    Items,
    dataTableConfigurations,
    dataCharts,
    dataTableItemsDebug,
    dragAndDrop,
    tabsFields,
    index,
    ErrorHolder,
    UserHistory,
    dashboard,
    dummy,
    pinnedNav
  }
})
